import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-palette-line',
    title: 'Branding & Identity',
    description: 'Build a powerful brand identity that sets you apart from the competition and connects with your target audience on a deeper level.',
    benefits: [
      'Logo design and brand guidelines',
      'Visual identity systems',
      'Brand strategy and positioning',
      'Marketing collateral design',
      'Brand refresh and evolution',
      'Style guides and brand books'
    ],
    outcomes: [
      'Memorable brand presence',
      'Consistent visual communication',
      'Increased brand recognition',
      'Professional credibility'
    ],
    image: 'https://public.readdy.ai/ai/img_res/baad3f461c969ec04116c6c847f7a17c.jpg'
  },
  {
    icon: 'ri-pencil-ruler-2-line',
    title: 'Graphic Design',
    description: 'Professional graphic design services that bring your vision to life with creativity, strategic thinking, and attention to detail.',
    benefits: [
      'Marketing materials and brochures',
      'Social media graphics and templates',
      'Infographics and presentations',
      'Packaging and label design',
      'Annual reports and publications',
      'Event materials and invitations'
    ],
    outcomes: [
      'Eye-catching visual content',
      'Clear message communication',
      'Enhanced marketing effectiveness',
      'Professional brand image'
    ],
    image: 'https://readdy.ai/api/search-image?query=confident%20African%20American%20female%20graphic%20designer%20working%20at%20a%20modern%20professional%20studio%20desk%20with%20large%20monitor%20displaying%20colorful%20branding%20and%20poster%20designs%2C%20stylus%20pen%20in%20hand%20reviewing%20vibrant%20creative%20artwork%2C%20professional%20creative%20workspace%20with%20warm%20natural%20lighting%2C%20minimalist%20clean%20background%2C%20focused%20and%20inspired&width=800&height=600&seq=graphicdesignafam1&orientation=landscape'
  },
  {
    icon: 'ri-store-2-line',
    title: 'Signage Solutions',
    description: 'Custom signage design and fabrication that captures attention, enhances your space, and drives foot traffic to your business.',
    benefits: [
      'Storefront and exterior signage',
      'Interior wayfinding systems',
      'Vehicle wraps and decals',
      'Banners and trade show displays',
      'Window graphics and murals',
      'Coroplast, Aluminum, &amp; foamcore Signs'
    ],
    outcomes: [
      'Increased visibility and foot traffic',
      'Professional business presence',
      'Enhanced customer experience',
      'Durable, weather-resistant solutions'
    ],
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/abbdf39b-605e-4b73-97a1-0a769abb1891_Together-we-request-the-company-of-your-presence-to-celebrate-the-marriage-of-12-x-18-in-1.svg?v=7499999be0d0d9e8223c60b42669fe94'
  },
  {
    icon: 'ri-printer-line',
    title: 'Print Solutions',
    description: 'High-quality print services that make a lasting impression, from business cards to large-format printing and everything in between.',
    benefits: [
      'Business cards and stationery',
      'Brochures and flyers',
      'Posters and large-format prints',
      'Catalogs and booklets',
      'Direct mail campaigns',
      'Promotional materials'
    ],
    outcomes: [
      'Premium quality prints',
      'Tangible marketing materials',
      'Professional first impressions',
      'Cost-effective solutions'
    ],
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/ac941379-c554-40e9-8c76-265602300faf_Together-we-request-the-company-of-your-presence-to-celebrate-the-marriage-of-12-x-18-in-2.svg?v=29dc46b0bb9824bb2d7cea50cef3d9ed'
  },
  {
    icon: 'ri-global-line',
    title: 'Web Design & Development',
    description: 'Modern, responsive websites that look great, function flawlessly, and convert visitors into customers.',
    benefits: [
      'Custom website design',
      'Responsive mobile-first development',
      'E-commerce solutions',
      'Content management systems',
      'SEO optimization',
      'Website maintenance and support'
    ],
    outcomes: [
      'Professional online presence',
      'Improved user experience',
      'Higher conversion rates',
      'Mobile-friendly design'
    ],
    image: 'https://readdy.ai/api/search-image?query=modern%20website%20design%20mockup%20on%20computer%20screen%20showing%20responsive%20web%20design%2C%20clean%20and%20professional%20website%20interface%20with%20elegant%20layout%2C%20contemporary%20web%20development%20workspace&width=800&height=600&seq=service8&orientation=landscape'
  },
  {
    icon: 'ri-shirt-line',
    title: 'Custom T-Shirts and Apparel',
    description: 'From single pieces to bulk orders, we print vibrant, long-lasting custom apparel for businesses, events, sports teams, schools, and more. Whether you need screen printing, embroidery, or direct-to-garment (DTG) printing, we deliver wearable branding that makes a statement.',
    benefits: [
      'Custom screen printing (single & multi-color)',
      'Embroidery for hats, polos & uniforms',
      'Direct-to-garment (DTG) full-color printing',
      'Hoodies, long sleeves & performance wear',
      'Low minimums — no order too small',
      'Bulk discounts for large team or event orders',
      'Heat transfer & vinyl lettering options',
      'Rush turnaround available'
    ],
    outcomes: [
      'Wearable branding your team will be proud of',
      'Sharp, vibrant prints that last wash after wash',
      'On-time delivery for events & giveaways',
      'Affordable pricing for any budget or quantity'
    ],
    image: 'https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/50a25aea-0b27-45aa-8367-272015f796a0_Together-we-request-the-company-of-your-presence-to-celebrate-the-marriage-of-12-x-18-in.svg?v=63721be176d90a3a6b293c923f027057'
  }
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <span className="text-[#06B6D4] text-sm font-semibold uppercase tracking-wider">
              Our Services
            </span>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mt-4 mb-6 leading-tight">
              Comprehensive Creative Solutions For Your Business
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              From branding to signage to print, we offer a full range of creative services designed to help your business stand out and succeed.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="w-full mb-16">
            <img
              src="https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/04a9c4ec-93e8-4764-9ebc-27c76b6bbede_SIGNS-1.svg?v=b0b17f32ea0dcc4cdad5ede5bac64d7d"
              alt="CZ Signs & Graphics"
              className="w-full h-auto object-contain"
            />
          </div>
          <div className="space-y-16">
            {services.map((service, index) => (
              <div
                key={index}
                className="grid grid-cols-1 lg:grid-cols-3 gap-0 rounded-2xl overflow-hidden border border-gray-100"
              >
                {/* Content */}
                <div className="lg:col-span-2 p-10">
                  <h2 className="text-3xl font-bold text-gray-900 mb-3">
                    {service.title}
                  </h2>
                  <p className="text-base text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>

                  <div className="mb-6">
                    <h3 className="text-base font-bold text-gray-900 mb-3">What We Offer:</h3>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      {service.benefits.map((benefit, i) => (
                        <li key={i} className="flex items-start space-x-2">
                          <i className="ri-checkbox-circle-fill text-[#06B6D4] text-base mt-0.5 flex-shrink-0"></i>
                          <span className="text-gray-700 text-sm">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-5">
                    <h3 className="text-base font-bold text-gray-900 mb-3">Expected Outcomes:</h3>
                    <ul className="space-y-1.5">
                      {service.outcomes.map((outcome, i) => (
                        <li key={i} className="flex items-center space-x-2">
                          <i className="ri-arrow-right-s-line text-[#06B6D4]"></i>
                          <span className="text-gray-700 text-sm">{outcome}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Side Banner Image */}
                <div className="lg:col-span-1 w-full h-64 lg:h-auto">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-600 mb-10">
            Let's discuss how we can help elevate your brand and achieve your goals.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center bg-gray-900 text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-gray-800 transition-all duration-200 hover:shadow-2xl whitespace-nowrap group"
          >
            Book a Consultation
            <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}